import { axiosClassic, axiosWithAuth } from '../api/interceprots'
import { setAuthCookies } from '../api/tokens'
import { IReferralsStats } from '@/types/referrals.types'
export const AccountService = {
	async getAccountInfo() {
		const response = await axiosWithAuth.get(`/account`)
		return response.data
	},
	async getReferralsStats() {
		const response = await axiosWithAuth.get<IReferralsStats>(`/account/referrals/stats`)
		return response.data
	},
	async editPassword(old_password: string, new_password: string) {
		const response = await axiosWithAuth.put(`/account/password`, {
			old_password,
			new_password,
		})
		return response.data
	},
	async editNames(username: string, firstname: string) {
		const response = await axiosWithAuth.patch(`/account`, {
			username,
			first_name: firstname,
		})
		return response.data
	},
	async fastRegister(email: string, invite_code?: string) {
		const response = await axiosClassic.post(`/auth/fast_register`, {
			email,
			invite_code,
		})
		setAuthCookies(response.data)
	},
	async newPassword(new_password: string) {
		const response = await axiosWithAuth.put('/account/new_password', {
			new_password,
		})
		return response.data
	},
}
